<mat-form-field class="w-full">
    <mat-label>{{ caption }}</mat-label>
    <mat-chip-grid class="p-4" #chipList [required]="required">
        @for (chip of control.value; track chip; let i = $index) {
            <mat-chip-row [value]="chip" [removable]="true" (removed)="removeChip(i)">
                {{ chipMask ? (getCaption(chip, 'chip') | localize) : chip.displayName }}
                @if (!readonly) {
                    <mat-icon class="icon-size-5" matChipRemove [svgIcon]="'heroicons_solid:minus-circle'"></mat-icon>
                }
            </mat-chip-row>
        }
        <input [matChipInputFor]="chipList" [placeholder]="placeholder" [matChipInputAddOnBlur]="true" [formControl]="searchCtrl" [readonly]="readonly"
            [matChipInputSeparatorKeyCodes]="separators" (matChipInputTokenEnd)="add($event)" [matAutocomplete]="ac">
        <mat-autocomplete #ac="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="displayFn">
            @for (opt of options | async; track opt) {
                <mat-option [value]="opt">
                    {{ optionMask ? (getCaption(opt, 'option') | localize) : opt.caption }}
                </mat-option>
            }
        </mat-autocomplete>
    </mat-chip-grid>
    @if (hint) {
        <mat-hint>{{ hint }}</mat-hint>
    }
    @if (!control.disabled && control.touched && control.errors) {
        <mat-error>
            @if (control.hasError('required')) {
                {{ 'errorRequiredField' | transloco }}
            } @else if (control.hasError('minlength')) {
                {{ 'errorMinLengthField' | transloco:{ requiredLength: control.errors.minlength.requiredLength } }}
            } @else if (control.hasError('maxlength')) {
                {{ 'errorMaxLengthField' | transloco:{ requiredLength: control.errors.maxlength.requiredLength } }}   
            }
        </mat-error>
    }
</mat-form-field>